// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import rfDroneServices from './reducer'
export default rfDroneServices

export {
  setProjectsData,
  setSitesData,
  // setPanoramaData,
  // setModelData,
  // setVideoData,
  // setDesignOverlayData,
} from './actions'

export {
  getProjectsData,
  getSitesData,
  // getPanoramaData,
  // getModelData,
  // getVideoData,
  // getDesignOverlayData,
} from './thunks'
